module.exports = __webpack_public_path__ + "img/Plan10.0f6aeb2b.jpg";